import React from 'react';
import FBTextField from '../FBTextField/FBTextField';

const FBSalesOrderNumber: React.FC = (props) => {
  return (
    <>
      <FBTextField {...props} />
    </>
  );
};

export default FBSalesOrderNumber;
